import React, { useEffect, useMemo, useState } from 'react'
import CoverImage from '../CoverImage'
import { useElementRect } from '../../hooks/useElementRect'

export default function ExpandedCover({
  playerRef,
  isExpanded,
  setIsExpanded,
  currentTrack,
  API_URL,
}) {
  const memoizedCoverImage = useMemo(
    () => (
      <CoverImage
        currentTrack={currentTrack}
        API_URL={API_URL}
        onClick={() => {
          setIsExpanded((prev) => !prev)
        }}
        isExpanded={isExpanded}
        className="big-cover-image"
      />
    ),
    [currentTrack, API_URL, isExpanded, setIsExpanded],
  )

  const rect = useElementRect(playerRef)
  const [sizeBigCoverImage, setSizeBigCoverImage] = useState(null)

  // sätt storleken när rect (och ev. expand-läge) uppdateras
  useEffect(() => {
    if (isExpanded && rect) {
      setSizeBigCoverImage(Math.min(rect.width, rect.top))
    }
  }, [isExpanded, rect])

  useEffect(() => {
    // console.log({ isExpanded, rect, sizeBigCoverImage, currentTrack })
  }, [isExpanded, rect, sizeBigCoverImage, currentTrack])

  // Debug the conditional rendering
  // useEffect(() => {
  //   console.log('Conditional render debug:', {
  //     isExpanded,
  //     rect: !!rect,
  //     sizeBigCoverImage: !!sizeBigCoverImage,
  //     currentTrack: !!currentTrack,
  //     rectValue: rect,
  //     sizeBigCoverImageValue: sizeBigCoverImage,
  //   })
  // }, [isExpanded, rect, sizeBigCoverImage, currentTrack])

  return (
    <>
      {/* {isExpanded && rect && sizeBigCoverImage != null && currentTrack && ( */}
      {isExpanded && rect && sizeBigCoverImage != null && currentTrack && (
        <div
          className="big-cover-image-container"
          style={{
            top: `calc(${rect.top - sizeBigCoverImage}px + 3rem)`,
            // left: rect.left,
            width: `calc(${sizeBigCoverImage}px - 0rem)`,
            height: `calc(${sizeBigCoverImage}px - 0rem)`,
          }}
        >
          {memoizedCoverImage}
        </div>
      )}
    </>
  )
}
